export const PAGE_SIZE_DEFAULT = 10;
export const ON_NO_OF_RECORDS_CHANGED_DEFAULT = 10;
export const CHECKED_OUT_TO_ME = "CHECKED_OUT_TO_ME";
export const CHECK_IN_FROM_TEAMS = "CHECK_IN_FROM_TEAMS";
export const GET_TEMPLATE = "GET_TEMPLATE";

export const SEARCH_TYPE_BASIC = "BASIC_SEARCH";
export const SEARCH_TYPE_ADVANCE = "ADVANCED_SEARCH";
export const SEARCH_TYPE_DEFAULT = SEARCH_TYPE_BASIC;

export const SEARCH_BY_FILE_NAME = "SEARCH_BY_FILE_NAME";
export const SEARCH_BY_CONTENT = "SEARCH_BY_CONTENT";
export const SEARCH_BY_DEFAULT = SEARCH_BY_FILE_NAME;
export const SEARCH_VALUE_DEFAULT = "";
export const CLICK_COPY_LINK = false;
export const CLICK_SHARE_LINK = false;
export const CLICK_SHARE_DOCUMENT = false;
export const IS_TOOL_BAR_DISABLED = true;
export const MORE_DETAILS_IS_MODAL_DEFAULT = false;
export const MORE_TEMPLATE_DETAILS_IS_MODAL_DEFAULT = false;
export const HIDE_SIDE_BAR = "HIDE_SIDE_BAR";
export const SMALL_SCREEN_SIZE = "SMALL_SCREEN_SIZE";

export const DEFAULT_PREVIOUS_SEARCH_VALUE = "";
export const DEFAULT_SEARCH_RESULT_COUNT = 0;
export const DEFAULT_ONEDRIVE_SEARCH_RESULT_COUNT = 0;
export const DEFAULT_MESSAGE_BOX_VISIBLE = false;
export const DEFAULT_DIALOG_VISIBLE = false;
export const DEFAULT_SUCESS_DIALOG_VISIBLE = false;
export const DEFAULT_DIALOG_TYPE = "CREATEPDF";

export const DEFAULT_SELECTED_PAGE_INDEX = 0;
export const INITIAL_ROW_SELECTION_DETAILS = [];
export const DEFAULT_MAIN_COMP_WIDTH = 0;

export const RELEASE_LEVEL_EMPTY = "";
export const RELEASE_LEVEL_LATEST = "LATEST";
export const RELEASE_LEVEL_LATEST_RELEASED = "LATEST_RELEASED";
export const RELEASE_LEVEL_DEFAULT = RELEASE_LEVEL_LATEST;
export const RELEASE_LEVEL_START_DATE = "";
export const RELEASE_LEVEL_END_DATE = "";
export const RELEASE_LEVEL_ANY_DATE = false;
export const RELEASE_LEVEL_ONLY_WHERE_USER_INVOLVED = false;
export const RELEASE_LEVEL_DOC_CLASS = "";
export const RELEASE_LEVEL_FORMAT = "";
export const ACTIVE_PAGE = "HOME";

export const COPY_LINK_TOGGLE_VALUE_DEFAULT = "VIEW";
export const COPY_LINK_TOGGLE_VALUE_DOWNLOAD = "VIEW";
export const LINK_PLATFORM = "linkToIFSAurena";
export const UPLOADED_LINKS = [];

export const ONEDRIVE_OPTIONS_DATE = "";
export const ONEDRIVE_PASSWORD = "";
export const DEFAULT_ONEDRIVE_OPTIONS_SELECTED_PEOPLE = [];
export const DEFAULT_CONTACTS = [];
export const DEFAULT_ONE_DRIVE_LINK_SETTING_OPTION = "ANYONE_WITH_LINK";

export const LARGE_SCREEN = "LARGE_SCREEN";
export const MEDIUM_SCREEN = "MEDIUM_SCREEN";
export const SMALL_SCREEN = "SMALL_SCREEN";
export const MOBILE_POTRAIT_SCREEN = "MOBILE_POTRAIT_SCREEN";
export const TAB_POTRAIT_SCREEN = "TAB_POTRAIT_SCREEN";

export const VALID_TOKEN = "VALID_TOKEN";
export const INVALID_TOKEN = "INVALID_TOKEN";
export const TOKEN_VALIDATE = "TOKEN_VALIDATE";
export const UNAUTHORIZED_ACCESS = "UNAUTHORIZED_ACCESS";

export const ENV_INFO_RECIEVED = "ENV_INFO_RECIEVED";
export const ENV_INFO_LOADING = "ENV_INFO_LOADING";
export const ENV_INFO_INVALID = "ENV_INFO_INVALID";

export const DOCCLASS_VALUES = "DOCCLASS_VALUES";
export const LOGICALUNIT_VALUES = "LOGICALUNIT_VALUES";
export const DOCCLASS_FORMAT_VALUES = "DOCCLASS_FORMAT_VALUES";

export const ONEDRIVE_FILES_LIST = "ONEDRIVE_FILES_LIST";
export const CHECKIN_NEW = "Check-in New";
export const CHECKIN_NEW_REVISION = "Check-in New Revision";
export const CHECKIN_FORM_LAYOUT_MIN_WIDTH_PX = 960;
export const CHECKIN_EXISTING_REVISION = "Check-in";
export const CHECKIN_BUTTON_TEXT_TYPE = {
  checkinNew: "Check-in New",
  checkinNewRevision: "Check-in",
  checkinExisting: "Check-in",
};
export const ON_CHECKIN_NEW_PAGE_NAME = "ON_CHECKIN_NEW_PAGE_NAME";
export const TIME_OUT_STATUS_CODE = 408;
export const MAX_TOKEN_REFRESH = 1;
export const PAGE_NAME = {
  home: "HOME",
  allDocuments: "ALL_DOCUMENTS",
  checkoutToMe: "CHECKED_OUT_TO_ME",
  checkInFromTeams: "CHECK_IN_FROM_TEAMS",
  checkInDocuments: "CHECK_IN_DOCUMENTS",
  checkInNewRevision: "CHECK_IN_NEW_REVISION",
  workingDocuments: "WORKING_DOCUMENTS",
};

export const CHECKIN_NEW_PAGE_NAME = {
  file: "File Upload",
  basic: "Basic",
  connection: "Connections",
  recentObjects: "Recent Objects",
  advanceObjects: "Advance Search",
};
export const LOADER_ACTIVE = false;
export const URL_GENERATE = "";

export const ON_SEARCH_DISABLE = "ON_SEARCH_DISABLE";
export const ON_EMPTY_RESULTS = "ON_EMPTY_RESULTS";
export const ON_REVISION_SEARCH_LOAD = "ON_REVISION_SEARCH_LOAD";
export const ON_ADV_OBJ_MODEL_HIDE = "ON_ADV_OBJ_MODEL_HIDE";
export const ON_ADV_OBJ_RECORD_SELECTED = "ON_ADV_OBJ_RECORD_SELECTED";

export const ADV_SEARCH_OBJ_MAX_ROW = 25;
export const FILE_DRAG_AND_DROP = "Upload a file up to 5MB";
export const FILE_DRAG_AND_DROP_HIGHLIGHTED = "Upload a file";
export const FILE_DRAG_AND_DROP_PDF = "Upload a PDF file";
export const FILE_DRAG_AND_DROP_TEXT = " or drag and drop file";
export const FILE_DRAG_AND_DROP_SIZE = "(up to 20 MB)";
export const FILE_AUTO_ENABLE = "Automatically generate view copy for";
export const FILE_AUTO_ENABLE_SUB = "Word documents";
export const UPLOAD_FILE_REMOVE = "Remove";
export const FILE_SUCCESSFULLY_UPLOADED = "successfully uploaded";
export const OBJECT_SUCCESSFULLY_ADDED = "successfully added";
export const CREATE_VIEW_COPY_SUPPORT =
  "Create view copy only supports Word documents.";

export const UPLOADING_FILE = "  Uploading...";
export const DOWNLOADING_FILE = "  Downloading...";
export const VIEW_COPY_TYPE = "PDF";
export const NAVIGATION_PAGE = {
  home: "HOME",
  checkoutToMe: "CHECKED_OUT_TO_ME",
  checkinFromTeams: "CHECK_IN_FROM_TEAMS",
  allDocuments: "ALL_DOCUMENTS",
  templates: "TEMPLATES",
};

export const INVALID_DOCUMENT = "invalid";

export const DOCUMENT_ACCESS_TYPE = {
  ifs: "IFS",
  IfsRevision: "IFSRevision",
  oneDrive: "OneDrive",
};

export const ETAG_TYPE = {
  ifsDocumentLoad: "IFS_DOCUMENT_LOAD",
  oneDriveDocumentLoad: "ONEDRIVE_DOCUMENT_LOAD",
};

export const DOC_CHECK_IN_TYPE = {
  none: "None",
  checkinNew: "Check-in New",
  checkinNewRevision: "Check-in New Revision",
  checkinExisting: "Check-in Existing Revision",
  deleteExisting: "Delete Existing",
};
export const ON_CHECKIN_NEW_STATUS = {
  onLoad: "OnLoad",
  refresh: "Refresh",
  tabRefreh: "TabRefresh",
  completed: "Completed",
  clear: "Clear",
  noDate: "NoData",
  error: "Error",
};

export const OBJECT_SELECT_TYPE = {
  recent: "Recent",
  advance: "Advance",
};

export const CHECKED_IN_TYPE = {
  start: "Start",
  checkedIn: "CheckedIn",
  viewCopyFailed: "ViewCopyFailed",
};

export const CHECKOUT_STATUS = {
  checkout: "Checkout",
  undoCheckout: "UndoCheckout",
};

export const CHECKOUT_TYPE = {
  checkout: "Checked Out",
  undoCheckout: "Undo Checked Out",
};

export const FILE_STATE = {
  checkedIn: "Checked In",
  checkedOut: "Checked Out",
};

export const STATE = {
  released: "Released",
  preliminary: "Preliminary",
  approved: "Approved",
};

export const CHECKIN_PROCESS_TYPE = {
  start: "Start",
  checkin: "Checkin",
};

export const ADV_RESULTS_STATUS = {
  loading: "Loading",
  loadData: "loadData",
  dataLoaded: "DataLoaded",
};

export const DATA_LOAD_STATUS = {
  onStart: "OnStart",
  onLoad: "OnLoad",
  onPageLoad: "OnPageLoad",
  refresh: "Refresh",
  inProgress: "InProgress",
  tabRefreh: "TabRefresh",
  completed: "Completed",
  partialCompleted: "Partial Completed",
  clear: "Clear",
  noDate: "NoData",
  error: "Error",
  onConfigurationFailure: "onConfigurationFailure",
  ifsError: "IFS Error",
  oneDriveError: "OneDrive Error",
  inactiveUser: "Inactive User",
  progressBar: "ProgressBar",
  forbidden: "forbidden",
  onAuthorization: "onAuthorization",
  onAuthentication: "onAuthentication",
  unathorizedAccess: "unathorizedAccess",
  onIfsAuthorization: "onIfsAuthorization",
  ifsUnathorizedAccess: "ifsUnathorizedAccess",
};

export const PROGRESS_STATUS = {
  onStart: "OnStart",
  onLoad: "OnLoad",
  onLoading: "OnLoading",
  onRefresh: "OnRefresh",
  noData: "NoData",
  onError: "OnError",
  onCompletion: "OnCompletion",
  onUnauthorized: "onUnauthorized",
  onForbidden: "onForbidden",
};

export const DOCUMENT_LOAD_STATUS = {
  onStart: "OnStart",
  onLoad: "OnLoad",
  onLoading: "OnLoading",
  onRefresh: "OnRefresh",
  onDownloading: "onDownloading",
  onUploading: "onUploading",
  onDeleting: "onDeleting",
  onUpdating: "onUpdating",
  onViewCopyUpload: "onViewCopyUpload",
  noData: "NoData",
  onError: "OnError",
  onUploadError: "OnUploadError",
  onCompletion: "OnCompletion",
  onUnauthorized: "onUnauthorized",
};

export const USER_DATA_LOAD_STATUS = {
  onStart: "OnStart",
  onLoad: "OnLoad",
  onLoading: "OnLoading",
  onRefresh: "OnRefresh",
  onConfigurationFailure: "onConfigurationFailure",
  onAzureUserAuthentication: "onAzureUserAuthentication",
  onAzureUnauthorizedUser: "onAzureUnauthorizedUser",
  onIFSUserValidation: "onIFSUserValidation",
  onIfsUserAuthenticationFailure: "OnIfsUserAuthenticationFailure",
  onIFSUserLogin: "onIFSUserLogin",
  onLoginFailure: "onLoginFailure",
  onIfsUserAuthentication: "onIfsUserAuthentication",
  onIfsUnauthorizedUser: "OnUnauthorizedIfsUser",
  onCompletion: "OnCompletion",
  onError: "OnError",
};

export const USER_TOKEN_STATUS = {
  authorized: "Authorized",
  expired: "Expired",
  invalid: "Invalid",
  unauthorized: "Unauthorized",
  refresh: "Refresh",
};

export const ACCESS_TOKEN_STATUS = {
  valid: "Valid",
  fetch: "Fetch",
  refresh: "Refresh",
  expired: "Expired",
  invalid: "Invalid",
};

export const DOCUMENT_MODE = {
  ifs: "IfsDocuments",
  oneDrive: "OneDriveDocuments",
};

export const ENV_NAME = {
  dev: "Dev",
  qa: "QA",
  test: "Test",
  prod: "Prod",
};

export const THEME_MODE = {
  dark: "dark",
  default: "default",
  contrast: "contrast",
};

export const FILE_TYPES = {
  allFiles: "",
  docx: "DOCX",
  xlsx: "XLSX",
  pptx: "PPTX",
  pdf: "PDF",
};

export const ONEDRIVE_FILE_TYPES = {
  allFiles: "",
  docx: "word",
  xlsx: "excel",
  pptx: "powerpoint",
  pdf: "pdf",
};

export const ONEDRIVE_ROOT = {
  mainMenu: "MainMenu",
  ifsDocPreview: "IfsDocPreview",
  channelDoc: "ChannelDoc",
};

export const IFS_ACCESS_LEVEL = {
  admin: "ADMIN",
  edit: "EDIT",
  view: "VIEW",
  noAccess: "NOACCESS",
  noData: "NODATA",
};

export const MANDATORY_TYPE = {
  yes: "Y",
  no: "N",
};

export const OPERATION_TYPE = {
  DOWNLOAD: "DOWNLOAD",
  CHECKOUT: "CHECKOUT",
  CHECKIN_EXISTING: "CHECKIN_EXISTING",
};

export const SEARCH_VALUE_ENCODING = {
  HASH_SYMBOL: "#",
  HASH_ENCODED: "%23",
  AMPERSAND_SYMBOL: "&",
  AMPERSAND_ENCODED: "%26",
  SEARCH_VALUE_DEFAULT: "",
};

export const MODEL_STATUS = {
  close: false,
  open: true,
};

export const TEAMS_CHANNEL_STATUS = {
  VALID: "VALID",
  INVALID: "INVALID",
  CHECKING: "CHECKING",
};

export const REFRESH_TOKEN_ACTION = {
  none: "None",
  checkinNew: "CheckinNew",
  checkinNewRevision: "CheckinNewRevision",
  checkinExisting: "CheckinExisting",
  checkinNewViewCopy: "CheckinNewViewCopy",
  checkinNewRevisionViewCopy: "CheckinNewRevisionViewCopy",
  checkinExistingViewCopy: "CheckinExistingViewCopy",
  documentLoad: "DocumentLoad",
  documentBasicInfoLoad: "DocumentBasicInfoLoad",
  logicalUnitsLoad: "LogicalUnitsLoad",
  recentlyUsedObjectsLoad: "RecentlyUsedObjectsLoad",
  advanceSearchObjectColumnssLoad: "AdvanceSearchObjectColumnssLoad",
  advanceSearchObjectsLoad: "AdvanceSearchObjectsLoad",
  newRevisionInfoLoad: "newRevisionInfoLoad",
  newRevisionInfoLoadSearch: "newRevisionInfoLoadSearch",
  workingDocumentDetailsLoad: "workingDocumentDetailsLoad",
  workingDocumentsLoad: "workingDocumentsLoad",
  documentCheckoutLoad: "documentCheckoutLoad",
  documentSearchLoad: "documentSearchLoad",
};

export const RESPONSE_TYPE = {
  none: "NONE",
  success: "SUCCESS",
  failure: "FAILURE",
};

export const DEFAULT_REFRESH_TOKEN_PRE_ACTION = {
  actionType: REFRESH_TOKEN_ACTION.none,
  retry: 0,
};

export const DEFAULT_REFRESH_TOKEN_ACTION_INVOKED = {
  actionType: REFRESH_TOKEN_ACTION.none,
  retry: 0,
  refreshResponse: RESPONSE_TYPE.none
};
